import modelBase from '../../models/model-base.model';

var userSearchModal = {

  getUDFList: function (successCallBack, failureCallBack, countryID) {
    var path = '/api/udf/user/' + countryID;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getUserRoleList: function (successCallBack, failureCallBack, countryID) {
    let filter = {};
    if (countryID) {
      filter.CountryCode = countryID;
    }
    const qs = modelBase.toQueryString(filter);
    modelBase.get(successCallBack, failureCallBack, '/api/codemaster/UserRole?' + qs);
  },
  getUserAttributeList: function (successCallBack, failureCallBack, masterId, pageIndex, pageSize, name) {
    var path = '/api/udf/datalist?UDFMasterID=' + masterId + '&PageIndex=' + pageIndex + '&PageSize=' + pageSize + '&UDFValue=' + name;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getStoreGroupList: function (successCallBack, failureCallBack, filter) {
    const qs = modelBase.toQueryString(filter);
    modelBase.get(successCallBack, failureCallBack, '/api/site/search/sitegroup?' + qs);
  },
  getStoreList: function (successCallBack, failureCallBack, filter) {
    const qs = modelBase.toQueryString(filter);
    modelBase.get(successCallBack, failureCallBack, '/api/site/search/site?' + qs);
  },
  getTaskMasterList: function (successCallBack, failureCallBack, taskName, pageIndex, pageSize) {
    let urlParams = "?TaskName=" + taskName + "&PageIndex=" + pageIndex + "&PageSize=" + pageSize;
    modelBase.get(successCallBack, failureCallBack, '/api/task' + urlParams);
  },
  getUserBySupervisor: function (successCallBack, failureCallBack, user, country) {
    modelBase.get(successCallBack, failureCallBack, '/api/user/search/idname?UserIdOrName=' + user + '&CountryCode=' + country);
  }

}

export default userSearchModal;
